export enum WebhookEvent {
  PROJECT_PUBLISHED = 'project_published',
  IMPORT_FINISHED = 'import_finished',
  IMPORT_FINISHED_EMPTY = 'import_finished_empty',
  COMMENT_ADDED = 'comment_added',
  TAG_PROMOTED = 'tag_promoted',
}
